import { DateMessage, RouteRequestInput, Trip, Waypoint, } from "../../generated/gpb/api/route";
import { RouteId, TripId } from "../../generated/gpb/api/id";
import SupportDialog from "../SupportDialog";
import { formatDate } from "./tripUtils";

export type TripHelpInfo = {
    readonly trip?: Trip,
    readonly tripID?: TripId,
    readonly routeID?: RouteId,
    readonly errors?: Array<string>,
    readonly input?: RouteRequestInput,
    readonly formattedForecastTime?: string,
};
export function dateToString( dateMsg: DateMessage )
{
    const date = new Date( dateMsg.year, dateMsg.month - 1, dateMsg.day );
    return formatDate( date, false );
}
type ButtonProps = {
    readonly onClose: () => void,
    readonly open: boolean,
    readonly helpInfo: TripHelpInfo,
};
export function getStartRouteName( routeInfo: RouteRequestInput | undefined )
{
    if ( routeInfo === undefined ) return undefined;
    return getStartWaypointName( routeInfo.waypoints );
}
export function getEndRouteName( routeInfo: RouteRequestInput | undefined )
{
    if ( routeInfo === undefined ) return undefined;
    return getEndWaypointName( routeInfo.waypoints );
}
export function getStartWaypointName( waypoints: Array<Waypoint> | undefined )
{
    if ( waypoints === undefined ) return undefined;
    if ( waypoints.length < 1 ) return undefined;
    if ( waypoints[0].location === undefined ) return undefined;
    return waypoints[0].location.locationName;
}
export function getEndWaypointName( waypoints: Array<Waypoint> | undefined )
{
    if ( waypoints === undefined ) return undefined;
    if ( waypoints.length < 2 ) return undefined;
    if ( waypoints[waypoints.length - 1].location === undefined ) return undefined;
    return waypoints[waypoints.length - 1].location?.locationName;
}
export function getStartWaypoint( waypoints: Array<Waypoint> | undefined )
{
    if ( waypoints === undefined ) return undefined;
    if ( waypoints.length < 1 ) return undefined;
    return waypoints[0];
}
export function getEndWaypoint( waypoints: Array<Waypoint> | undefined )
{
    if ( waypoints === undefined ) return undefined;
    if ( waypoints.length < 2 ) return undefined;
    return waypoints[waypoints.length - 1];
}

function createEmailText(
    name: string | undefined,
    routeInfo: RouteRequestInput | undefined,
    tripID: TripId | undefined,
    routeID: RouteId | undefined,
    errors: Array<string> | undefined,
    formattedForecastTime: string | undefined,
)
{
    const tripname = name ?? "Missing Trip Name";
    const startingPoint = getStartRouteName( routeInfo ) ?? "Not Provided";
    const destination = getEndRouteName( routeInfo ) ?? "Not Provided";
    const tripDate =
  routeInfo !== undefined && routeInfo.startDate !== undefined
      ? dateToString( routeInfo.startDate )
      : "Not Provided";
    const trip = tripID !== undefined ? tripID.hexString : "Not Provided";
    const route = routeID !== undefined ? routeID.hexString : "Missing route ID";

    let errorText: string | undefined = undefined;
    if ( errors && errors.length > 0 )
    {
        errorText = "";
        for ( let i = 0; i < errors.length - 1; i++ )
        {
            errorText += errors[i] + ", ";
        }
        errorText += errors[errors.length - 1];
    }

    return `Trip ID: ${trip}
Route ID: ${route}
Trip Name: ${tripname}
Starting Point: ${startingPoint}, Destination: ${destination}
Trip Start Date: ${tripDate}
${formattedForecastTime !== undefined ? `Forecast Time : ${formattedForecastTime}` : ""}
Errors: ${errorText ?? "None"}`;
}

function createEmailSubject( name: string | undefined )
{
    const tripName = name ?? "Missing Trip Name";
    return `Trip Routing Help Request: ${tripName}`;
}

export default function TripSupportDialog( {
    open,
    onClose,
    helpInfo,
}: ButtonProps )
{

    const emailSubject = createEmailSubject( helpInfo.trip?.name );
    const emailText = createEmailText(
        helpInfo.trip?.name,
        helpInfo.input,
        helpInfo.tripID,
        helpInfo.routeID,
        helpInfo.errors,
        helpInfo.formattedForecastTime
    );
    return (
        <SupportDialog
            Subject = {emailSubject}
            Body = {emailText}
            open = {open}
            onClose = {onClose}
        />
    );
}
